import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import commonUtil from "../../../../../../../utils/commonUtil";
import Image from "../../../../../../../components/ZUILib/Image";
import Warning2 from "../../../../../../../components/Warning2";
import ModalPopover from "./../../../../../../../components/ZUILib/ModalPopover";
import ProgressBar from "../../../../../../../components/ZUILib/ProgressBar";
import ItemStatusBar from "../../RegalosRecibidosContent/components/ItemStatusBar";
import ProductCard from "../../RegalosRecibidosContent/components/ProductCard";
import OrderDetails from "../../RegalosRecibidosContent/components/OrderDetails";
import StatusTag from "../../RegalosRecibidosContent/components/StatusTag";

import * as defaultConst from "../../../../../../../utils/clientConstant";
import * as giftListActions from "../../../actions";

const { addAgainGiftItem, getTrackOrder, getRegisteredGiftList } =
  giftListActions;

const channel = commonUtil.getChannel();

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

const addAgainEnableStatus = [defaultConst.eventStatus.ACTIVE, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS, defaultConst.eventStatus.UNDER_REVIEW];

class ComprasModalOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
    };
    this.warningMessage = '';
  }

  selectedProduct = this.props.selectedProduct;

  componentDidMount() {
    this.setState({ title: this.props.title || "" });
    document.body.classList.add("body-no-scroll");
  }

  addAgain = (skuId) => {
    addAgainGiftItem(this.props.eventId, skuId)
      .then((response) => {
        if (response.body.status?.status === "success") {
          this.props.getRegisteredGiftList(this.props.eventId, this.props.registeredGiftListPriceOrder, "", "");
          if(this.props.isWap){
            this.props.hideModalOverlay();
            this.props.showMessagePopUp(true);
          } else {
            this.warning.setMessage(
              commonUtil.getLabel(
                this.props.lables.EventAdminPage,
                "adminpage.regalosrecibidos.gift.added.success.message"
              )
            );
          }
        } else {
          if(this.props.isWap){
            this.props.hideModalOverlay();
            this.props.showMessagePopUp(false);
          } else {
            this.errorMessage.setMessage(
              commonUtil.getLabel(
                this.props.lables.EventAdminPage,
                "adminpage.regalosrecibidos.add.again.failure.message"
              )
            );
          }
        }
      })
      .catch((e) => {
         if(this.props.isWap){
          this.props.hideModalOverlay();
          this.props.showMessagePopUp(false);
        } else {
          this.errorMessage.setMessage(
            commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.add.again.failure.message"
            )
          );
        }
        console.log(e);
      }); // console required
  };

  render() {
    const { title } = this.state;
    const { isWap, lables, selectedProduct } = this.props;


    let addAgainEnableStatusBtn = this.props.compareEventStatus(this.props.eventStatus,addAgainEnableStatus) && (this.selectedProduct.categoryName !== 'Gift Certificate' && this.selectedProduct.categoryName !== 'Certificado Electrónico');

    return (
      <div id="event-gift-modal-overlay" className="evnt_modal_overlay">
        <div className="modal-content-event">
          <div className="evnt-modal-header">
            <h4 className="modal-title">{title}</h4>
            <button
              className="close-button"
              onClick={this.props.hideModalOverlay}
              aria-label="Cerrar modal"
            >
              <img
                src={commonUtil.getAssetURL() + "/images/close.svg"}
                alt=""
                className="icon_vozcliente"
              />
            </button>
          </div>
          <div className="evnt_modal_body" onClick={(e) => e.stopPropagation()}>
            {!isWap &&
              <>
              <Warning2
                type="success"
                text={this.warningMessage}
                ref={(warning) => (this.warning = warning)}
                notSetToTop="true"
                onClose={true}
              />
              <Warning2
                type="error"
                text={this.errorMessage}
                ref={(errorMessage) => (this.errorMessage = errorMessage)}
                notSetToTop="true"
                onClose={true}
              />
              </>}
            <div className={`product-container`}>
              {isWap ? (
                <div className={`data-container`}>
                  <ProductCard
                    isWap={isWap}
                    selectedProduct={this.props.selectedProduct}
                    eventType={this.props.eventType}
                    eventId={this.props.eventId}
                    lables={this.props.lables}
                    giftSectionType={this.props.giftSectionType}
                    compareEventStatus={this.props.compareEventStatus}
                    eventTypes={eventTypes}
                  />

                  {this.props.compareEventStatus(
                    this.selectedProduct.deliveryStatus,
                    "physical.delivery.message"
                  ) ? (
                    <ItemStatusBar 
                      eventId={this.props.eventId}
                      selectedProduct={this.props.selectedProduct}
                      getTrackOrderData={this.props.getTrackOrder}
                      trackOrderData={this.props.trackOrderInfo}
                      loadingTrackOrder={this.props.loadingTrackOrder}
                      trackOrderFailed={this.props.trackOrderFailed}
                    />
                  ) : (
                    <React.Fragment>
                      {this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "electronic.delivery.message"
                      ) ||
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "store.delivery.message"
                      ) ||
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "cancel.delivery.message"
                      ) || 
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "return.delivery.message"
                      ) || 
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "return.reinvested.delivery.message"
                      ) ? (
                        <StatusTag
                          type={this.selectedProduct.deliveryStatus}
                          eventId={this.props.eventId}
                          lables={this.props.lables}
                        />
                      ) : (
                        <StatusTag
                          type={((this.selectedProduct?.modeofDelivery === "physical") ? "physical" : this.selectedProduct.deliveryStatus)}
                          eventId={this.props.eventId}
                          lables={this.props.lables}
                        />
                      )}
                    </React.Fragment>
                  )}

                  <OrderDetails
                    isWap={isWap}
                    isComprasModal={true}
                    selectedProduct={this.props.selectedProduct}
                    eventType={this.props.eventType}
                    eventId={this.props.eventId}
                    lables={this.props.lables}
                    compareEventStatus={this.props.compareEventStatus}
                  />
                </div>
              ) : (
                <>
                  <ProductCard
                    isWap={isWap}
                    selectedProduct={this.props.selectedProduct}
                    eventType={this.props.eventType}
                    eventId={this.props.eventId}
                    lables={this.props.lables}
                    giftSectionType={this.props.giftSectionType}
                    compareEventStatus={this.props.compareEventStatus}
                    eventTypes={eventTypes}
                  />

                  {this.props.compareEventStatus(
                    this.selectedProduct.deliveryStatus,
                    "physical.delivery.message"
                  ) ? (
                    <ItemStatusBar 
                      eventId={this.props.eventId}
                      selectedProduct={this.props.selectedProduct}
                      getTrackOrderData={this.props.getTrackOrder}
                      trackOrderData={this.props.trackOrderInfo}
                      loadingTrackOrder={this.props.loadingTrackOrder}
                      trackOrderFailed={this.props.trackOrderFailed}
                    />
                  ) : (
                    <React.Fragment>
                      {this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "electronic.delivery.message"
                      ) ||
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "store.delivery.message"
                      ) ||
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "cancel.delivery.message"
                      ) || 
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "return.delivery.message"
                      ) || 
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "return.reinvested.delivery.message"
                      ) ? (
                        <StatusTag
                          type={this.selectedProduct.deliveryStatus}
                          eventId={this.props.eventId}
                          lables={this.props.lables}
                        />
                      ) : (
                        <StatusTag
                          type={((this.selectedProduct?.modeofDelivery === "physical") ? "physical" : this.selectedProduct.deliveryStatus)}
                          eventId={this.props.eventId}
                          lables={this.props.lables}
                        />
                      )}
                    </React.Fragment>
                  )}

                  <OrderDetails
                    isWap={isWap}
                    isComprasModal={true}
                    selectedProduct={this.props.selectedProduct}
                    eventType={this.props.eventType}
                    eventId={this.props.eventId}
                    lables={this.props.lables}
                    compareEventStatus={this.props.compareEventStatus}
                  />
                </>
              )}

              <div
                id="#event-gift-modal-overlay"
                className={`col-xs-12 col-sm-12 mb-90 col-lg-12 button-border-top margin-top-auto button-padding`}
              >
                <div className="buttonBlock newButtonBlock">
                  {
                    selectedProduct.actionType === 'cancel' || selectedProduct.actionType === 'return' || selectedProduct.actionType === 'returnReinvested' ? (
                      <button
                        disabled={addAgainEnableStatusBtn ? false : true}
                        className={`btnPrimary size-Large size-Full ${addAgainEnableStatusBtn ? '' : 'disabledButton'}`}
                        style={{backgroundColor: addAgainEnableStatusBtn && this.props?.selectedTheme?.color_500}}
                        aria-hidden="false"
                        onClick={isWap?() => this.addAgain(this.selectedProduct.skuId) : () => this.props.addAgain(this.selectedProduct.skuId)}
                      >
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.addagain.label"
                        )}
                      </button>
                    ) : null
                  }
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  eventStatus:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventStatus,
  trackOrderInfo: state.giftList.data.trackOrderInfo,
  loadingTrackOrder: state.giftList.loadingTrackOrder,
  trackOrderFailed: state.giftList.trackOrderFailed,
  eventType:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventType,
  registeredGiftListPriceOrder: state.giftList.data.registeredGiftList?.originalRegisteredGiftList?.priceOrder || 'Ascending',
});
const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addAgainGiftItem,
      getTrackOrder,
      getRegisteredGiftList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ComprasModalOverlay);
